<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.inHouseServiceNav.overview')" link="inHouseServices" />
    <template v-for="ihsType in enums['InHouseServiceType']">
      <item-nav-group v-if="!isEmpty(inHouseServices)" :open="ihsType === activeItemType" :label="$t(`InHouseServiceType.${ihsType}`)" :key="ihsType">
        <template v-for="inHouseService in inHouseServices" v-if="inHouseService.type === ihsType && !inHouseService.deleted">
          <item-nav-group-item :label="getName(inHouseService.name)" :params="routeParams(inHouseService.id)" :key="inHouseService.id" link="inHouseService" />
        </template>
      </item-nav-group>
    </template>
    <item-nav-group v-if="!isEmpty(deletedInHouseServices)" :open="'deleted' === activeItemType" :label="$t('layout.nav.admin.inHouseServiceNav.deletedInHouseServices')">
      <item-nav-group-item v-for="inHouseService in deletedInHouseServices"
                           :label="getName(inHouseService.name)"
                           :params="routeParams(inHouseService.id)"
                           :key="inHouseService.id"
                           link="inHouseService" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'InHouseServiceNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      inHouseServices: [],
    };
  },

  computed: {
    deletedInHouseServices: function () {
      return this.inHouseServices.filter(it => it.deleted === true);
    },
    activeItemType: function () {
      if (isEmpty(this.inHouseServices)) return null;

      const ihs = this.inHouseServices.find(it => it.id === this.$route.params.inHouseServiceId);

      if (isNil(ihs)) return null;

      if (ihs.deleted === true) return 'deleted';

      return ihs.type;
    },
  },

  created: function () {
    this.updateInHouseServices();

    this.$serviceBus.$on('inHouseService.list', this.updateInHouseServices);
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('inHouseService.list', this.updateInHouseServices);
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updateInHouseServices(data = null) {
      if (!isNil(data)) {
        this.inHouseServices = data;
        return;
      }

      this.axios.get(this.serviceUrls.inHouseService.list(this))
        .then((response) => {
          this.inHouseServices = sortBy(response.data.data, obj => obj.name[this.hotelSettings.details.primaryLanguage]);
        });
    },
    getName(name) {
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeParams(inHouseServiceId) {
      return {
        inHouseServiceId: inHouseServiceId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/InHouseServiceNav.vue